module.exports = __webpack_public_path__ + "resources/img/img_hacking_testing2_m_jp.4ffae83eac9acb6b6d5a70d60729dfb3.png";